// Outside links used in the account menu (Help). Leave a value empty to hide that item.
export const LINKS = {
  /** Where "Download the app" goes (App Store / TestFlight / a download page). */
  app: 'https://apps.apple.com/us/app/opsalo/id6816284483',
  terms: 'https://opsalo.com/terms',
  privacy: 'https://opsalo.com/privacy',
  /** Shown as "Report a problem" (mailto). */
  supportEmail: 'hello@opsalo.com',
  /** The written user guide, once it exists. */
  guide: 'https://opsalo.com/guide',
};
